import Vue from 'vue'
import Vuex from 'vuex'
import ApiService from "../../common/api.service"
import vm from '../../main.js'
import { SET_LOGGEDIN, SET_USERNAME, SET_WALLETS, UPDATE_WALLETS } from "./mutation.type"
import { USER_INIT, USER_REGISTER, USER_LOGIN, USER_WALLETS, SOCKET_UPDATEWALLET } from "./action.type"
import { ToastProgrammatic as Toast } from 'buefy'

Vue.use(Vuex)

export default {
  state: {
    loggedIn: false,
    username: "",
    wallets: []
  },
  mutations: {
    [SET_LOGGEDIN](state, data) {
      state.loggedIn = data
    },
    [SET_USERNAME](state, data) {
      state.username = data
    },
    [SET_WALLETS](state, data) {
      state.wallets = data
    },
    [UPDATE_WALLETS](state, data) {
      state.wallets = state.wallets.map(wallet => {
        if(wallet.address == data.address) return data
        return wallet
      })
    },
  },
  actions: {
    async [USER_INIT](context, payload) {
      const response = await ApiService.get("user/me")
      if (response.status == 200) {
        context.commit(SET_LOGGEDIN, true)
        context.commit(SET_USERNAME, response.data.username)
        context.dispatch(USER_WALLETS)
      }
    },
    async [USER_REGISTER](context, payload) {
      const response = await ApiService.post("user/register", payload)
      if (response.status == 400) {
        return Toast.open({
          type: "is-danger",
          message: "Username already exists"
        })
      }

      Toast.open({
        type: "is-success",
        message: "Your account has been registered"
      })

      context.commit(SET_LOGGEDIN, true)
      context.commit(SET_USERNAME, payload.username)
      return response
    },
    async [USER_LOGIN](context, payload) {
      const response = await ApiService.post("auth/login", payload)
      if (response.status == 401) {
        return Toast.open({
          type: "is-danger",
          message: "Incorrect username/password"
        })
      }

      Toast.open({
        type: "is-success",
        message: "You have been logged in"
      })

      context.commit(SET_LOGGEDIN, true)
      context.commit(SET_USERNAME, payload.username)

      return response
    },
    async [USER_WALLETS](context, payload) {
      const response = await ApiService.get("/user/wallets")

      context.commit(SET_WALLETS, response.data)
    },
    async [SOCKET_UPDATEWALLET](context, data) {
      context.commit(UPDATE_WALLETS, data)
    }
  }
}
